<div class="patient-search">
  <h4>Patient Search Results</h4>
  <hr />
  <div class="patient-search-table-wrapper" id="patient-search-table-wrapper">
    <table
      mat-table
      matSort
      matSortStart="asc"
      matSortActive="firstName"
      matSortDirection="asc"
      [dataSource]="protoReferralSource"
      class="data-table table-fixed-head w-100"
      id="patient-search-data-table"
      aria-label="List of patient search results"
    >
      <tr class="mat-row" *matNoDataRow>
        <td
          class="mat-cell text-center p-2"
          [colSpan]="displayedPatientColumns.length"
        >
          <span>No patients match the search criteria.</span>
        </td>
      </tr>

      <!-- First Name Column -->
      <ng-container matColumnDef="firstName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by First Name"
          id="patient-search-column-firstname"
          class="p-2"
        >
          First Name
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          {{ row.firstName }}
        </td>
      </ng-container>

      <!-- Last Name Column -->
      <ng-container matColumnDef="lastName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Last Name"
          id="patient-search-column-lastname"
          class="p-2"
        >
          Surname
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          {{ row.lastName }}
        </td>
      </ng-container>

      <!-- Hospital Number Column -->
      <ng-container matColumnDef="patientExternalId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Hospital Number"
          id="patient-search-column-patientExternalId"
          class="p-2"
        >
          Hospital Number
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          {{ row.patientExternalId }}
        </td>
      </ng-container>

      <!-- DOB Column -->
      <ng-container matColumnDef="dateOfBirth">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Date of Birth"
          id="patient-search-column-dateOfBirth"
          class="p-2"
        >
          Date of Birth
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          {{ row.dateOfBirth | date: 'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <!-- Site Name Column -->
      <ng-container matColumnDef="siteName">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Site Name"
          id="patient-search-column-siteName"
          class="p-2"
        >
          Site Name
        </th>
        <td mat-cell *matCellDef="let row" class="p-2">
          {{ row.siteName }}
        </td>
      </ng-container>

      <!-- Rows -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayedPatientColumns; sticky: true"
      ></tr>
      <tr
        mat-row
        (click)="onPatientRowClick(row)"
        [class.selectedRow]="
          selectedProtoReferral?.patientExternalId === row.patientExternalId &&
          selectedProtoReferral?.siteId === row.siteId
        "
        *matRowDef="let row; columns: displayedPatientColumns"
        class="clickable"
      ></tr>
    </table>
  </div>

  @if(selectedProtoReferral) {
  <div class="selected-proto-referral-details">
    <h4>Regions for Scanning</h4>
    <span>Choose regions for vetting request</span>
    <div class="scan-regions-table-wrapper">
      <table
        mat-table
        [dataSource]="scanRegionsSource"
        class="data-table table-fixed-head w-100"
        id="scan-regions-data-table"
        aria-label="List of scan regions for selected patient"
      >
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef id="select">
            <mat-checkbox
              (change)="$event ? toggleAllScanRegionRows() : null"
              [checked]="
                scanRegionSelection.hasValue() && allScanRegionsSelected
              "
              [indeterminate]="
                scanRegionSelection.hasValue() && !allScanRegionsSelected
              "
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="p-2">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (keyup)="$event.stopPropagation()"
              (change)="scanRegionSelection.toggle(row)"
              [checked]="scanRegionSelection.isSelected(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Modality Column -->
        <ng-container matColumnDef="modality">
          <th mat-header-cell *matHeaderCellDef id="modality">
            <div class="p-2">Modality</div>
          </th>
          <td mat-cell *matCellDef="let row" class="p-2">
            {{ row.modality }}
          </td>
        </ng-container>

        <!-- Body Part Column -->
        <ng-container matColumnDef="bodyPart">
          <th mat-header-cell *matHeaderCellDef id="bodyPart">
            <div class="p-2">Body Part/Procedure</div>
          </th>
          <td mat-cell *matCellDef="let row" class="p-2">
            {{ row.bodyPart }}
          </td>
        </ng-container>

        <!-- Phase of Contrast Column -->
        <ng-container matColumnDef="phaseOfContrast">
          <th mat-header-cell *matHeaderCellDef id="phaseOfContrast">
            <div class="p-2">Phase of Contrast</div>
          </th>
          <td mat-cell *matCellDef="let row" class="p-2">
            {{ row.phaseOfContrast }}
          </td>
        </ng-container>

        <!-- Rows -->
        <tr
          mat-header-row
          *matHeaderRowDef="displayedScanRegionsColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedScanRegionsColumns"
          class="scan-region-row"
        ></tr>
      </table>
    </div>
  </div>
  }

  <hr />
  <div class="actions">
    <button
      mat-stroked-button
      id="cancel-search"
      mat-button
      type="button"
      (click)="cancelSearch()"
    >
      Cancel Search
    </button>
    <button
      mat-stroked-button
      id="load-details"
      mat-button
      type="button"
      [disabled]="!selectedProtoReferral"
      (click)="onLoadClick()"
    >
      Load Details
    </button>
  </div>
</div>
